import { inject, Injectable } from '@angular/core';
import { DefaultService } from '@intouch/fines-portal-api';
import { map, Observable } from 'rxjs';
import { normalizeError } from 'shared/core/data-access/error';
import {
    fileToTemporaryFile,
    TemporaryFile,
    AbstractTemporaryFileService,
} from 'shared/form/data-access/form';
import {
    httpEventToProgress,
    mapProgressBody,
    Progress,
} from 'shared/framework/data-access/angular';

@Injectable({
    providedIn: 'root',
})
export class FileService implements AbstractTemporaryFileService {
    #finesPortalApi = inject(DefaultService);

    uploadTemporaryFile = (file: File): Observable<Progress<TemporaryFile>> => {
        const blob = new Blob([file], { type: file.type });

        return this.#finesPortalApi
            .uploadTemporaryFile(blob, file.name, 'events', true)
            .pipe(
                map((event) => httpEventToProgress(event)),
                mapProgressBody((response) =>
                    fileToTemporaryFile(file, response.uuid),
                ),
                normalizeError(
                    $localize`:@@fileUpload.upload.error:Could not upload file`,
                ),
            );
    };
}
